import { COUNTRIES_LIST } from "../const";

export const getCountryValuesFromCountriesList = countryFullName => {
  const countryValues = COUNTRIES_LIST.find(c => c.name === countryFullName);
  const dropdownCountryValue = countryFullName;
  const countryWageValue = countryValues.wageAmount;
  const countryShortName = countryValues.shortName;
  return { dropdownCountryValue, countryWageValue, countryShortName };
};

export const findExpenseDataCurrentExpenseData = (id, expenseList) => {
  const expenseData = expenseList.filter(ex => ex.id === id);
  return expenseData[0];
};
